import React, { RefObject, useState } from 'react'
import CheckboxInput from '../inputs/checkbox.input'
import RadioInput from '../inputs/radio.input'
import { CheckboxList, RadioList } from '@utils/request'
import * as utilsList from './__index.utils'
import { Direction } from '@services/constants'
import MeasurementInput from '../inputs/measurement.input'
import TextAreaInput from '../inputs/textarea.inputs'
import { joinClasses } from '@utils/styles'
import TextInput from '../inputs/text.inputs'
import workImage from '../../../images/entree-charretiere.svg'
import Notification from '@components/ui/notification'
import { formatStrapiText } from '@utils/methods'

const Step4_3LandDevelopmentWork = ({
	pageAssets,
	pageUtils,
	formInputs,
	errors,
	updateInput,
	onFixError,
	isSummaryStep = false,
	// *******
	updateCheckBoxInput
}) => {
	const {
		typesOfWorkToPerformParking,
		modificationsDrivewayEntranceParking,
		parkingDevelopmentOrModificationDetailsParking,
		areOtherModificationsInvolvedParking,

		existingWidthParking1,
		desiredWidthParking1,
		desiredModificationLeftParking1,
		desiredModificationRightParking1,
		desiredModificationLeftDistanceParking1,
		desiredModificationRightDistanceParking1,
		existingWidthParkingUnit1,
		desiredWidthParkingUnit1,
		desiredModificationLeftDistanceParkingUnit1,
		desiredModificationRightDistanceParkingUnit1,

		existingWidthParking2,
		desiredWidthParking2,
		desiredModificationLeftParking2,
		desiredModificationRightParking2,
		desiredModificationLeftDistanceParking2,
		desiredModificationRightDistanceParking2,
		existingWidthParkingUnit2,
		desiredWidthParkingUnit2,
		desiredModificationLeftDistanceParkingUnit2,
		desiredModificationRightDistanceParkingUnit2,

		existingWidthParking3,
		desiredWidthParking3,
		desiredModificationLeftParking3,
		desiredModificationRightParking3,
		desiredModificationLeftDistanceParking3,
		desiredModificationRightDistanceParking3,
		existingWidthParkingUnit3,
		desiredWidthParkingUnit3,
		desiredModificationLeftDistanceParkingUnit3,
		desiredModificationRightDistanceParkingUnit3,

		workAreaParking,
		workAreaParkingUnit,

		wallModificationOrAdditionIsAddingOrMovingWallParking,
		wallModificationOrAdditionWallHeightParking,
		wallModificationOrAdditionWallHeightParkingUnit,
		wallModificationOrAdditionWallLengthParking,
		wallModificationOrAdditionWallLengthParkingUnit,
		wallModificationOrAdditionExistingMaterialParking,
		wallModificationOrAdditionProjectedMaterialParking,
		retainingWallModificationOrAdditionIsAddingOrMovingWallParking,
		retainingWallModificationOrAdditionWallHeightParking,
		retainingWallModificationOrAdditionWallHeightParkingUnit,
		retainingWallModificationOrAdditionWallLengthParking,
		retainingWallModificationOrAdditionWallLengthParkingUnit,
		retainingWallModificationOrAdditionExistingMaterialParking,
		retainingWallModificationOrAdditionProjectedMaterialParking,
		walkwayModificationOrAdditionWidthParking,
		walkwayModificationOrAdditionWidthParkingUnit,
		walkwayModificationOrAdditionExistingMaterialParking,
		walkwayModificationOrAdditionProjectedMaterialParking,
		blockNumber
	} = formInputs

	const handleAddClick = () => {
		if (blockNumber.value < 3)
			updateInput(blockNumber.name, blockNumber.value + 1)
	}

	const handleRemoveBlock = (indexToRemove: number) => {
		if (blockNumber.value <= 1 || indexToRemove > blockNumber.value) return

		const clearBlock = (index: number) => {
			updateInput(`existingWidthParking${index}`, '')
			updateInput(`desiredWidthParking${index}`, '')

			updateInput(`desiredModificationLeftParking${index}`, '')
			updateInput(`desiredModificationLeftDistanceParking${index}`, '')

			updateInput(`desiredModificationRightParking${index}`, '')
			updateInput(`desiredModificationRightDistanceParking${index}`, '')
		}

		const copyBlock = (from: number, to: number) => {
			updateInput(
				`existingWidthParking${to}`,
				formInputs[`existingWidthParking${from}`]?.value || ''
			)
			updateInput(
				`desiredWidthParking${to}`,
				formInputs[`desiredWidthParking${from}`]?.value || ''
			)

			updateInput(
				`desiredModificationLeftParking${to}`,
				formInputs[`desiredModificationLeftParking${from}`]?.value || ''
			)
			updateInput(
				`desiredModificationLeftDistanceParking${to}`,
				formInputs[`desiredModificationLeftDistanceParking${from}`]?.value || ''
			)

			updateInput(
				`desiredModificationRightParking${to}`,
				formInputs[`desiredModificationRightParking${from}`]?.value || ''
			)
			updateInput(
				`desiredModificationRightDistanceParking${to}`,
				formInputs[`desiredModificationRightDistanceParking${from}`]?.value ||
					''
			)
		}

		if (indexToRemove === blockNumber.value) {
			// Cas simple : suppression du dernier bloc visible
			clearBlock(indexToRemove)
			updateInput(blockNumber.name, blockNumber.value - 1)
		} else {
			// Cas complexe : suppression du bloc du milieu (ex: bloc 2)
			copyBlock(indexToRemove + 1, indexToRemove) // 3 → 2
			clearBlock(indexToRemove + 1) // vider bloc 3
			updateInput(blockNumber.name, blockNumber.value - 1)
		}
	}

	const isSectionA = utilsList.isGR6_3TypesOfWorkToPerformParkingSectionA(
		typesOfWorkToPerformParking.value
	)
	const isSectionB = utilsList.isGR6_3TypesOfWorkToPerformParkingSectionB(
		typesOfWorkToPerformParking.value
	)
	const isSectionC = utilsList.isGR6_3TypesOfWorkToPerformParkingSectionC(
		typesOfWorkToPerformParking.value
	)

	const isSectionW = utilsList.isGR6_3ParkingSectionW(
		areOtherModificationsInvolvedParking.value
	)
	const isSectionX = utilsList.isGR6_3ParkingSectionX(
		areOtherModificationsInvolvedParking.value
	)
	const isSectionY = utilsList.isGR6_3ParkingSectionY(
		areOtherModificationsInvolvedParking.value
	)

	const radioListisAddingOrMovingWallParking: RadioList[] =
		utilsList.radioListisAddingOrMovingWallParking(pageAssets)
	const radioListTypesOfWorkToPerformParking: RadioList[] =
		utilsList.radioListTypesOfWorkToPerformParking(pageAssets)

	const checkboxListModificationsDrivewayEntranceParking: CheckboxList[] =
		utilsList.checkboxListModificationsDrivewayEntranceParking(pageAssets)

	const checkboxListareOtherModificationsInvolvedParking: CheckboxList[] =
		utilsList.checkboxListAreOtherModificationsInvolvedParking(pageAssets)

	const radioListMeasurementUnit: RadioList[] =
		utilsList.radioListMeasurementUnit(pageAssets)

	const radioListMeasurement2Unit: RadioList[] =
		utilsList.radioListMeasurement2Unit(pageAssets)

	const radioListDesiredModificationParking: RadioList[] =
		utilsList.radioListDesiredModificationParking(pageAssets)

	const shouldDisplaySectionATitle = () => {
		return (
			!isSummaryStep ||
			parkingDevelopmentOrModificationDetailsParking.value ||
			workAreaParking.value ||
			areOtherModificationsInvolvedParking.value
		)
	}

	return (
		<>
			{/* Types of Work */}

			<RadioInput
				name={typesOfWorkToPerformParking.name}
				label={typesOfWorkToPerformParking.label}
				value={typesOfWorkToPerformParking.value}
				list={radioListTypesOfWorkToPerformParking}
				direction={Direction.vertical}
				hasError={errors!.includes(typesOfWorkToPerformParking.name)}
				onChange={(value) =>
					updateInput(typesOfWorkToPerformParking.name, value)
				}
				ref={typesOfWorkToPerformParking.ref as RefObject<HTMLInputElement>}
				required={typesOfWorkToPerformParking.required}
				hasBackgroundWrapper={true}
				isSummaryStep={isSummaryStep}
			/>

			{isSectionA && shouldDisplaySectionATitle() && (
				<h4 className={pageUtils.classes.h4}>
					{formatStrapiText(
						pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_firstOption
					)}
				</h4>
			)}

			{isSectionB && (
				<h4 className={pageUtils.classes.h4}>
					{formatStrapiText(
						pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_secondOption
					)}
				</h4>
			)}

			{isSectionC && (
				<h4 className={pageUtils.classes.h4}>
					{formatStrapiText(
						pageAssets?.request_form_LandDevelopmentWork_typesOfWorkToPerformParking_thirdOption
					)}
				</h4>
			)}

			{/* Question 11 : Renseignements sur l'aménagement ou la modification du stationnement */}
			{(isSectionA || isSectionC) && (
				<TextAreaInput
					id={parkingDevelopmentOrModificationDetailsParking.name}
					label={parkingDevelopmentOrModificationDetailsParking.label}
					value={parkingDevelopmentOrModificationDetailsParking.value}
					onChange={(value) =>
						updateInput(
							parkingDevelopmentOrModificationDetailsParking.name,
							value
						)
					}
					hasError={errors!.includes(
						parkingDevelopmentOrModificationDetailsParking.name
					)}
					required={parkingDevelopmentOrModificationDetailsParking.required}
					ref={
						parkingDevelopmentOrModificationDetailsParking.ref as RefObject<HTMLTextAreaElement>
					}
					maxCharacters={500}
					hasDescriptionLabel={
						parkingDevelopmentOrModificationDetailsParking.description
					}
					displayDescriptionTop
					descriptionAlignment="left"
					rows={4}
					isSummaryStep={isSummaryStep}
				/>
			)}

			{/* Question 11.1 : Superficie des travaux */}
			{isSectionA && (
				<MeasurementInput
					measurementInput={workAreaParking}
					unitInput={workAreaParkingUnit}
					listMeasurementUnit={radioListMeasurement2Unit}
					maxCharacters={12}
					isSummaryStep={isSummaryStep}
					errors={errors}
					onFixError={onFixError}
					updateInput={updateInput}
					hasError={errors?.includes(workAreaParking.name)}
					reducedMargin
					disableWarningTooltip
				/>
			)}

			{/* Modifications souhaitées */}

			{(isSectionB || isSectionC) && (
				<>
					<CheckboxInput
						name={modificationsDrivewayEntranceParking.name}
						label={modificationsDrivewayEntranceParking.label}
						description={modificationsDrivewayEntranceParking.description}
						value={`${modificationsDrivewayEntranceParking.value}`}
						list={checkboxListModificationsDrivewayEntranceParking}
						onChange={(value) =>
							updateCheckBoxInput(modificationsDrivewayEntranceParking, value)
						}
						required={modificationsDrivewayEntranceParking.required}
						hasError={errors.includes(
							modificationsDrivewayEntranceParking.name
						)}
						ref={
							modificationsDrivewayEntranceParking.ref as RefObject<HTMLInputElement>
						}
						errors={errors}
						shouldNotDivide
						hasBackgroundWrapper
						onFixError={onFixError}
						newCheckValue
						isSummaryStep={isSummaryStep}
					/>

					{(isSectionB || isSectionC) && (
						<>
							<h6 className={pageUtils.classes.h6}>
								{
									pageAssets?.request_form_LandDevelopmentWork_desiredModificationsTitle
								}
							</h6>

							<img
								style={{
									border: '1px solid #ccc',
									background: '#f7f7f8',
									padding: '0px',
									maxWidth: '550px',
									marginBottom: '20px'
								}}
								src={workImage}
							/>
						</>
					)}

					<div
						className={pageUtils.classes.fieldsContainer}
						style={{ alignItems: 'start' }}
					>
						<MeasurementInput
							measurementInput={existingWidthParking1}
							unitInput={existingWidthParkingUnit1}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(existingWidthParking1.name)}
							reducedMargin
							disableWarningTooltip
						/>
						<MeasurementInput
							measurementInput={desiredWidthParking1}
							unitInput={desiredWidthParkingUnit1}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(desiredWidthParking1.name)}
							reducedMargin
							disableWarningTooltip
						/>
						<div>
							<RadioInput
								name={desiredModificationLeftParking1.name}
								label={desiredModificationLeftParking1.label}
								value={desiredModificationLeftParking1.value}
								list={radioListDesiredModificationParking}
								direction={Direction.vertical}
								hasError={errors!.includes(
									desiredModificationLeftParking1.name
								)}
								onChange={(value) =>
									updateInput(desiredModificationLeftParking1.name, value)
								}
								ref={
									desiredModificationLeftParking1.ref as RefObject<HTMLInputElement>
								}
								required={desiredModificationLeftParking1.required}
								hasBackgroundWrapper={true}
								isSummaryStep={isSummaryStep}
							/>
							<MeasurementInput
								measurementInput={desiredModificationLeftDistanceParking1}
								unitInput={desiredModificationLeftDistanceParkingUnit1}
								listMeasurementUnit={radioListMeasurementUnit}
								maxCharacters={6}
								isSummaryStep={isSummaryStep}
								errors={errors}
								onFixError={onFixError}
								updateInput={updateInput}
								hasError={errors?.includes(
									desiredModificationLeftDistanceParking1.name
								)}
								reducedMargin
								disableWarningTooltip
							/>
						</div>
						<div>
							<RadioInput
								name={desiredModificationRightParking1.name}
								label={desiredModificationRightParking1.label}
								value={desiredModificationRightParking1.value}
								list={radioListDesiredModificationParking}
								direction={Direction.vertical}
								hasError={errors!.includes(
									desiredModificationRightParking1.name
								)}
								onChange={(value) =>
									updateInput(desiredModificationRightParking1.name, value)
								}
								ref={
									desiredModificationRightParking1.ref as RefObject<HTMLInputElement>
								}
								required={desiredModificationRightParking1.required}
								hasBackgroundWrapper={true}
								isSummaryStep={isSummaryStep}
							/>
							<MeasurementInput
								measurementInput={desiredModificationRightDistanceParking1}
								unitInput={desiredModificationRightDistanceParkingUnit1}
								listMeasurementUnit={radioListMeasurementUnit}
								maxCharacters={6}
								isSummaryStep={isSummaryStep}
								errors={errors}
								onFixError={onFixError}
								updateInput={updateInput}
								hasError={errors?.includes(
									desiredModificationRightDistanceParking1.name
								)}
								reducedMargin
								disableWarningTooltip
							/>
						</div>
					</div>

					{blockNumber.value >= 2 && (
						<>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center'
								}}
							>
								<h6 className={pageUtils.classes.h6}>
									{
										pageAssets?.request_form_LandDevelopmentWork_desiredModificationsTitle2
									}
								</h6>
								{!isSummaryStep && (
									<button
										className={joinClasses([
											pageUtils.classes.btn,
											pageUtils.classes.button,
											pageUtils.classes.buttonOutline
										])}
										style={{
											padding: '4px 16px',
											fontSize: '0.875rem',
											height: '30px'
										}}
										onClick={() => handleRemoveBlock(2)}
									>
										{pageAssets?.request_form_LandDevelopmentWork_removeButton}
									</button>
								)}
							</div>
							<div
								className={pageUtils.classes.fieldsContainer}
								style={{ alignItems: 'start' }}
							>
								<MeasurementInput
									measurementInput={existingWidthParking2}
									unitInput={existingWidthParkingUnit2}
									listMeasurementUnit={radioListMeasurementUnit}
									maxCharacters={6}
									isSummaryStep={isSummaryStep}
									errors={errors}
									onFixError={onFixError}
									updateInput={updateInput}
									hasError={errors?.includes(existingWidthParking2.name)}
									reducedMargin
								/>
								<MeasurementInput
									measurementInput={desiredWidthParking2}
									unitInput={desiredWidthParkingUnit2}
									listMeasurementUnit={radioListMeasurementUnit}
									maxCharacters={6}
									isSummaryStep={isSummaryStep}
									errors={errors}
									onFixError={onFixError}
									updateInput={updateInput}
									hasError={errors?.includes(desiredWidthParking2.name)}
									reducedMargin
								/>
								<div>
									<RadioInput
										name={desiredModificationLeftParking2.name}
										label={desiredModificationLeftParking2.label}
										value={desiredModificationLeftParking2.value}
										list={radioListDesiredModificationParking}
										direction={Direction.vertical}
										hasError={errors!.includes(
											desiredModificationLeftParking2.name
										)}
										onChange={(value) =>
											updateInput(desiredModificationLeftParking2.name, value)
										}
										ref={
											desiredModificationLeftParking2.ref as RefObject<HTMLInputElement>
										}
										required={desiredModificationLeftParking2.required}
										hasBackgroundWrapper={true}
										isSummaryStep={isSummaryStep}
									/>
									<MeasurementInput
										measurementInput={desiredModificationLeftDistanceParking2}
										unitInput={desiredModificationLeftDistanceParkingUnit2}
										listMeasurementUnit={radioListMeasurementUnit}
										maxCharacters={6}
										isSummaryStep={isSummaryStep}
										errors={errors}
										onFixError={onFixError}
										updateInput={updateInput}
										hasError={errors?.includes(
											desiredModificationLeftDistanceParking2.name
										)}
										reducedMargin
									/>
								</div>
								<div>
									<RadioInput
										name={desiredModificationRightParking2.name}
										label={desiredModificationRightParking2.label}
										value={desiredModificationRightParking2.value}
										list={radioListDesiredModificationParking}
										direction={Direction.vertical}
										hasError={errors!.includes(
											desiredModificationRightParking2.name
										)}
										onChange={(value) =>
											updateInput(desiredModificationRightParking2.name, value)
										}
										ref={
											desiredModificationRightParking2.ref as RefObject<HTMLInputElement>
										}
										required={desiredModificationRightParking2.required}
										hasBackgroundWrapper={true}
										isSummaryStep={isSummaryStep}
									/>
									<MeasurementInput
										measurementInput={desiredModificationRightDistanceParking2}
										unitInput={desiredModificationRightDistanceParkingUnit2}
										listMeasurementUnit={radioListMeasurementUnit}
										maxCharacters={6}
										isSummaryStep={isSummaryStep}
										errors={errors}
										onFixError={onFixError}
										updateInput={updateInput}
										hasError={errors?.includes(
											desiredModificationRightDistanceParking2.name
										)}
										reducedMargin
									/>
								</div>
							</div>
						</>
					)}

					{blockNumber.value == 3 && (
						<>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between',
									alignItems: 'center'
								}}
							>
								<h6 className={pageUtils.classes.h6}>
									{
										pageAssets?.request_form_LandDevelopmentWork_desiredModificationsTitle3
									}
								</h6>
								{!isSummaryStep && (
									<button
										className={joinClasses([
											pageUtils.classes.btn,
											pageUtils.classes.button,
											pageUtils.classes.buttonOutline
										])}
										style={{
											padding: '4px 16px',
											fontSize: '0.875rem',
											height: '30px'
										}}
										onClick={() => handleRemoveBlock(3)}
									>
										{pageAssets?.request_form_LandDevelopmentWork_removeButton}
									</button>
								)}
							</div>
							<div
								className={pageUtils.classes.fieldsContainer}
								style={{ alignItems: 'start' }}
							>
								<MeasurementInput
									measurementInput={existingWidthParking3}
									unitInput={existingWidthParkingUnit3}
									listMeasurementUnit={radioListMeasurementUnit}
									maxCharacters={6}
									isSummaryStep={isSummaryStep}
									errors={errors}
									onFixError={onFixError}
									updateInput={updateInput}
									hasError={errors?.includes(existingWidthParking3.name)}
									reducedMargin
								/>
								<MeasurementInput
									measurementInput={desiredWidthParking3}
									unitInput={desiredWidthParkingUnit3}
									listMeasurementUnit={radioListMeasurementUnit}
									maxCharacters={6}
									isSummaryStep={isSummaryStep}
									errors={errors}
									onFixError={onFixError}
									updateInput={updateInput}
									hasError={errors?.includes(desiredWidthParking3.name)}
									reducedMargin
								/>

								<div>
									<RadioInput
										name={desiredModificationLeftParking3.name}
										label={desiredModificationLeftParking3.label}
										value={desiredModificationLeftParking3.value}
										list={radioListDesiredModificationParking}
										direction={Direction.vertical}
										hasError={errors!.includes(
											desiredModificationLeftParking3.name
										)}
										onChange={(value) =>
											updateInput(desiredModificationLeftParking3.name, value)
										}
										ref={
											desiredModificationLeftParking3.ref as RefObject<HTMLInputElement>
										}
										required={desiredModificationLeftParking3.required}
										hasBackgroundWrapper={true}
										isSummaryStep={isSummaryStep}
									/>
									<MeasurementInput
										measurementInput={desiredModificationLeftDistanceParking3}
										unitInput={desiredModificationLeftDistanceParkingUnit3}
										listMeasurementUnit={radioListMeasurementUnit}
										maxCharacters={6}
										isSummaryStep={isSummaryStep}
										errors={errors}
										onFixError={onFixError}
										updateInput={updateInput}
										hasError={errors?.includes(
											desiredModificationLeftDistanceParking3.name
										)}
										reducedMargin
									/>
								</div>
								<div>
									<RadioInput
										name={desiredModificationRightParking3.name}
										label={desiredModificationRightParking3.label}
										value={desiredModificationRightParking3.value}
										list={radioListDesiredModificationParking}
										direction={Direction.vertical}
										hasError={errors!.includes(
											desiredModificationRightParking3.name
										)}
										onChange={(value) =>
											updateInput(desiredModificationRightParking3.name, value)
										}
										ref={
											desiredModificationRightParking3.ref as RefObject<HTMLInputElement>
										}
										required={desiredModificationRightParking3.required}
										hasBackgroundWrapper={true}
										isSummaryStep={isSummaryStep}
									/>
									<MeasurementInput
										measurementInput={desiredModificationRightDistanceParking3}
										unitInput={desiredModificationRightDistanceParkingUnit3}
										listMeasurementUnit={radioListMeasurementUnit}
										maxCharacters={6}
										isSummaryStep={isSummaryStep}
										errors={errors}
										onFixError={onFixError}
										updateInput={updateInput}
										hasError={errors?.includes(
											desiredModificationRightDistanceParking3.name
										)}
										reducedMargin
									/>
								</div>
							</div>
						</>
					)}
					{blockNumber.value < 3 && (
						<div style={{ display: 'flex', justifyContent: 'flex-start' }}>
							{!isSummaryStep && (
								<button
									className={joinClasses([
										pageUtils.classes.btn,
										pageUtils.classes.buttonOutline
									])}
									style={{
										left: '0',
										padding: '9px 20px',
										fontSize: '0.875rem',
										backgroundColor: '#0054a6',
										borderColor: '#0054a6',
										color: '#fff',
										marginTop: '15px'
									}}
									onClick={handleAddClick}
								>
									{pageAssets?.request_form_LandDevelopmentWork_addButton}
								</button>
							)}
						</div>
					)}
				</>
			)}

			{(!isSummaryStep || areOtherModificationsInvolvedParking.value) && (
				<h6 className={pageUtils.classes.h6}>
					{formatStrapiText(
						pageAssets?.request_form_buildingConstructionOrAdditionPermit_plannedWork_seventhOption
					)}
				</h6>
			)}
			<CheckboxInput
				name={areOtherModificationsInvolvedParking.name}
				label={areOtherModificationsInvolvedParking.label}
				description={areOtherModificationsInvolvedParking.description}
				value={`${areOtherModificationsInvolvedParking.value}`}
				list={checkboxListareOtherModificationsInvolvedParking}
				onChange={(value) =>
					updateCheckBoxInput(areOtherModificationsInvolvedParking, value)
				}
				required={areOtherModificationsInvolvedParking.required}
				hasError={errors.includes(areOtherModificationsInvolvedParking.name)}
				ref={
					areOtherModificationsInvolvedParking.ref as RefObject<HTMLInputElement>
				}
				errors={errors}
				shouldNotDivide
				hasBackgroundWrapper
				onFixError={onFixError}
				newCheckValue
				isSummaryStep={isSummaryStep}
			/>

			{/* Modification ou ajout d'un muret */}
			{isSectionW && (
				<>
					<h6 className={pageUtils.classes.h6}>
						{formatStrapiText(
							pageAssets?.request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_firstOption
						)}
					</h6>

					<RadioInput
						name={wallModificationOrAdditionIsAddingOrMovingWallParking.name}
						label={wallModificationOrAdditionIsAddingOrMovingWallParking.label}
						value={wallModificationOrAdditionIsAddingOrMovingWallParking.value}
						list={radioListisAddingOrMovingWallParking}
						direction={Direction.vertical}
						hasError={errors!.includes(
							wallModificationOrAdditionIsAddingOrMovingWallParking.name
						)}
						onChange={(value) =>
							updateInput(
								wallModificationOrAdditionIsAddingOrMovingWallParking.name,
								value
							)
						}
						ref={
							wallModificationOrAdditionIsAddingOrMovingWallParking.ref as RefObject<HTMLInputElement>
						}
						required={
							wallModificationOrAdditionIsAddingOrMovingWallParking.required
						}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					<div className={pageUtils.classes.fieldsContainer}>
						<MeasurementInput
							measurementInput={wallModificationOrAdditionWallHeightParking}
							unitInput={wallModificationOrAdditionWallHeightParkingUnit}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(
								wallModificationOrAdditionWallHeightParking.name
							)}
							reducedMargin
						/>

						<MeasurementInput
							measurementInput={wallModificationOrAdditionWallLengthParking}
							unitInput={wallModificationOrAdditionWallLengthParkingUnit}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(
								wallModificationOrAdditionWallLengthParking.name
							)}
							reducedMargin
						/>
					</div>

					<div className={pageUtils.classes.fieldsContainer}>
						<TextInput
							id={wallModificationOrAdditionExistingMaterialParking.name}
							label={wallModificationOrAdditionExistingMaterialParking.label}
							value={wallModificationOrAdditionExistingMaterialParking.value}
							onChange={(value) =>
								updateInput(
									wallModificationOrAdditionExistingMaterialParking.name,
									value
								)
							}
							hasError={errors.includes(
								wallModificationOrAdditionExistingMaterialParking.name
							)}
							required={
								wallModificationOrAdditionExistingMaterialParking.required
							}
							ref={
								wallModificationOrAdditionExistingMaterialParking.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>

						<TextInput
							id={wallModificationOrAdditionProjectedMaterialParking.name}
							label={wallModificationOrAdditionProjectedMaterialParking.label}
							value={wallModificationOrAdditionProjectedMaterialParking.value}
							onChange={(value) =>
								updateInput(
									wallModificationOrAdditionProjectedMaterialParking.name,
									value
								)
							}
							hasError={errors.includes(
								wallModificationOrAdditionProjectedMaterialParking.name
							)}
							required={
								wallModificationOrAdditionProjectedMaterialParking.required
							}
							ref={
								wallModificationOrAdditionProjectedMaterialParking.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>
					</div>
				</>
			)}

			{/* Modification ou ajout d'un mur de soutènement */}

			{isSectionX && (
				<>
					<h6 className={pageUtils.classes.h6}>
						{formatStrapiText(
							pageAssets?.request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_secondOption
						)}
					</h6>

					{!isSummaryStep && (
						<Notification
							text={
								pageAssets?.request_form_landDevWorkPermit_ajoutDeplacementMurSoutenement_notif
							}
							type="info"
							hasHtml
						/>
					)}

					<RadioInput
						name={
							retainingWallModificationOrAdditionIsAddingOrMovingWallParking.name
						}
						label={
							retainingWallModificationOrAdditionIsAddingOrMovingWallParking.label
						}
						value={
							retainingWallModificationOrAdditionIsAddingOrMovingWallParking.value
						}
						list={radioListisAddingOrMovingWallParking}
						direction={Direction.vertical}
						hasError={errors!.includes(
							retainingWallModificationOrAdditionIsAddingOrMovingWallParking.name
						)}
						onChange={(value) =>
							updateInput(
								retainingWallModificationOrAdditionIsAddingOrMovingWallParking.name,
								value
							)
						}
						ref={
							retainingWallModificationOrAdditionIsAddingOrMovingWallParking.ref as RefObject<HTMLInputElement>
						}
						required={
							retainingWallModificationOrAdditionIsAddingOrMovingWallParking.required
						}
						hasBackgroundWrapper={true}
						isSummaryStep={isSummaryStep}
					/>

					<div className={pageUtils.classes.fieldsContainer}>
						<MeasurementInput
							measurementInput={
								retainingWallModificationOrAdditionWallHeightParking
							}
							unitInput={
								retainingWallModificationOrAdditionWallHeightParkingUnit
							}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(
								retainingWallModificationOrAdditionWallHeightParking.name
							)}
							reducedMargin
						/>

						<MeasurementInput
							measurementInput={
								retainingWallModificationOrAdditionWallLengthParking
							}
							unitInput={
								retainingWallModificationOrAdditionWallLengthParkingUnit
							}
							listMeasurementUnit={radioListMeasurementUnit}
							maxCharacters={6}
							isSummaryStep={isSummaryStep}
							errors={errors}
							onFixError={onFixError}
							updateInput={updateInput}
							hasError={errors?.includes(
								retainingWallModificationOrAdditionWallLengthParking.name
							)}
							reducedMargin
						/>
					</div>

					<div className={pageUtils.classes.fieldsContainer}>
						<TextInput
							id={
								retainingWallModificationOrAdditionExistingMaterialParking.name
							}
							label={
								retainingWallModificationOrAdditionExistingMaterialParking.label
							}
							value={
								retainingWallModificationOrAdditionExistingMaterialParking.value
							}
							onChange={(value) =>
								updateInput(
									retainingWallModificationOrAdditionExistingMaterialParking.name,
									value
								)
							}
							hasError={errors.includes(
								retainingWallModificationOrAdditionExistingMaterialParking.name
							)}
							required={
								retainingWallModificationOrAdditionExistingMaterialParking.required
							}
							ref={
								retainingWallModificationOrAdditionExistingMaterialParking.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>

						<TextInput
							id={
								retainingWallModificationOrAdditionProjectedMaterialParking.name
							}
							label={
								retainingWallModificationOrAdditionProjectedMaterialParking.label
							}
							value={
								retainingWallModificationOrAdditionProjectedMaterialParking.value
							}
							onChange={(value) =>
								updateInput(
									retainingWallModificationOrAdditionProjectedMaterialParking.name,
									value
								)
							}
							hasError={errors.includes(
								retainingWallModificationOrAdditionProjectedMaterialParking.name
							)}
							required={
								retainingWallModificationOrAdditionProjectedMaterialParking.required
							}
							ref={
								retainingWallModificationOrAdditionProjectedMaterialParking.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>
					</div>
				</>
			)}

			{/* Modification ou ajout d'une allée piétonnière */}
			{isSectionY && (
				<>
					<h6 className={pageUtils.classes.h6}>
						{formatStrapiText(
							pageAssets?.request_form_landDevWorkPermit_areOtherModificationsInvolvedParking_thirdOption
						)}
					</h6>

					<MeasurementInput
						measurementInput={walkwayModificationOrAdditionWidthParking}
						unitInput={walkwayModificationOrAdditionWidthParkingUnit}
						listMeasurementUnit={radioListMeasurementUnit}
						maxCharacters={6}
						isSummaryStep={isSummaryStep}
						errors={errors}
						onFixError={onFixError}
						updateInput={updateInput}
						hasError={errors?.includes(
							walkwayModificationOrAdditionWidthParking.name
						)}
						reducedMargin
					/>

					<div className={pageUtils.classes.fieldsContainer}>
						<TextInput
							id={walkwayModificationOrAdditionExistingMaterialParking.name}
							label={walkwayModificationOrAdditionExistingMaterialParking.label}
							value={walkwayModificationOrAdditionExistingMaterialParking.value}
							onChange={(value) =>
								updateInput(
									walkwayModificationOrAdditionExistingMaterialParking.name,
									value
								)
							}
							hasError={errors.includes(
								walkwayModificationOrAdditionExistingMaterialParking.name
							)}
							required={
								walkwayModificationOrAdditionExistingMaterialParking.required
							}
							ref={
								walkwayModificationOrAdditionExistingMaterialParking.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>

						<TextInput
							id={walkwayModificationOrAdditionProjectedMaterialParking.name}
							label={
								walkwayModificationOrAdditionProjectedMaterialParking.label
							}
							value={
								walkwayModificationOrAdditionProjectedMaterialParking.value
							}
							onChange={(value) =>
								updateInput(
									walkwayModificationOrAdditionProjectedMaterialParking.name,
									value
								)
							}
							hasError={errors.includes(
								walkwayModificationOrAdditionProjectedMaterialParking.name
							)}
							required={
								walkwayModificationOrAdditionProjectedMaterialParking.required
							}
							ref={
								walkwayModificationOrAdditionProjectedMaterialParking.ref as RefObject<HTMLInputElement>
							}
							maxCharacters={50}
							isSummaryStep={isSummaryStep}
						/>
					</div>
				</>
			)}
		</>
	)
}

export default Step4_3LandDevelopmentWork
